"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RcrtClubUser = exports.RcrtClub = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class RcrtClub extends model_core_1.Base {
    image = null;
    name = '';
    phone = '';
    address = null;
    max = null;
    players = null;
    access_code = '';
    share_codes = [];
    club_users = new model_core_1.ChildArray();
    constructor(data, olMap) {
        super('clubs', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtClub);
    }
}
exports.RcrtClub = RcrtClub;
class RcrtClubUser extends model_core_1.Base {
    user = null;
    access_code = '';
    type = index_1.ERcrtUserType.NONE;
    role = index_1.ERcrtClubUserRole.NONE;
    constructor(data, olMap) {
        super('club_users', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtClubUser);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
    }
}
exports.RcrtClubUser = RcrtClubUser;
index_1.olm.clubs = (ref, map) => {
    return new RcrtClub(ref, map);
};
index_1.olm.club_users = (ref, map) => {
    return new RcrtClubUser(ref, map);
};
